module.exports = __webpack_public_path__ + "img/ic-topup.194cb45e.svg";